import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const OrderDeliveredIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      width="21"
      height="10"
      viewBox="0 0 21 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.6569 7.91406H6.16797"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.17188 3.39209H15.8511V2.07031"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5182 3.38708L13.4883 1.38281"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.95407 7.91369H1.83092C1.21897 7.91369 0.722656 7.47089 0.722656 6.92488V4.97056C0.722656 4.48115 1.12192 4.06829 1.66298 3.99504L6.1668 3.38579L9.17428 1.90087C10.6743 1.15843 12.4579 1.01529 14.0848 1.5047L19.2453 3.05285C19.6931 3.18936 19.9991 3.56555 19.9991 3.98838V6.92821C19.9991 7.47423 19.5028 7.91702 18.8909 7.91702H17.8647"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.56133 9.35427C5.44941 9.35427 6.16959 8.71172 6.16959 7.91934C6.16959 7.12696 5.44941 6.48438 4.56133 6.48438C3.67326 6.48438 2.95312 7.12696 2.95312 7.91934C2.95312 8.71172 3.67326 9.35427 4.56133 9.35427Z"
        stroke={color ?? 'current-color'}
        strokeMiterlimit="10"
      />
      <path
        d="M16.2645 9.35427C17.1525 9.35427 17.8727 8.71172 17.8727 7.91934C17.8727 7.12696 17.1525 6.48438 16.2645 6.48438C15.3764 6.48438 14.6562 7.12696 14.6562 7.91934C14.6562 8.71172 15.3764 9.35427 16.2645 9.35427Z"
        stroke={color ?? 'current-color'}
        strokeMiterlimit="10"
      />
      <path
        d="M0.722656 5.64062H1.72643"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0039 5.64062H20.0077"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.40625 6.375H13.3392" stroke={color ?? 'current-color'} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default OrderDeliveredIcon;
